import { type ReactNode } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import { useThemeStore } from '../stores/theme.store';
import { NotificationProvider } from './NotificationProvider';
import '../components/ui/global.css';

interface ThemeBootstrapProps {
  children: ReactNode;
}

/**
 * ThemeBootstrap Component
 *
 * Wraps the app with Ant Design ConfigProvider using theme from store
 * Theme is loaded by BootstrapLoader before this component renders
 */
export function ThemeBootstrap({ children }: ThemeBootstrapProps) {
  const { antdConfig } = useThemeStore();

  return (
    <ConfigProvider
      theme={antdConfig}
      getPopupContainer={() => document.body}
    >
      <AntdApp>
        <NotificationProvider>{children}</NotificationProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
